import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Realmente puedo romper el bloqueo en solo 3 días?',
  a: 'Sí. Cuando atacas la raíz del problema (tu voz e identidad interna), el desbloqueo es inmediato y estas lista para manifestar desde el amor sano y la abundancia.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después del pago. Recibes todo por email en menos de 5 minutos.'
}, {
  q: '¿Es solo teoría o incluye ejercicios prácticos?',
  a: 'Es 100% práctico. Cada día incluye ejercicios específicos que implementas inmediatamente.'
}, {
  q: '¿Funciona si nunca he hecho trabajo personal?',
  a: 'Absolutamente. Está diseñado para principiantes. Todo se explica paso a paso de forma simple.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white text-center" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <div className="text-4xl mb-4" data-id="element-16">❓</div>
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-12" data-id="element-17">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4 text-left" data-id="element-18">
            {faqs.map((faq, index) => <div key={index} className="border border-beige-200 rounded-xl overflow-hidden bg-beige-50/50" data-id="element-19">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                  <span className="font-semibold text-dark pr-4" data-id="element-21">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
                </button>
                <AnimatePresence data-id="element-23">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-24">
                      <div className="px-6 pb-4 text-gray-600" data-id="element-25">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}